













import { Component, Vue } from 'vue-property-decorator';
import LabelItem from './labelItem.vue';
import { LabelModule } from '@/store/modules/label';
import LabelModal from './labelModal.vue';

@Component({
  components: {
    LabelItem,
    LabelModal,
  },
})
export default class LabelBox extends Vue {
  get labels(): ILabel.IModel.ILabelClass[] {
    return LabelModule.labels;
  }
  private createLabel() {
    LabelModule.ToggleLabelModalVisible();
    LabelModule.InitLabelModal();
  }
}
